<template>
  <div class="todo-container">
    <div>
      <div class="search" ref="searchRef">
        <searchTools
          @searchList="searchList"
          @resetQuery="resetQuery"
          :queryParams="queryParams"
          :loading="loading"
        />
      </div>
      <a-row type="flex" justify="end">
        <a-button
          type="primary"
          style="margin: 20px 24px 0 0"
          :loading="exportLoading"
          @click="handleExport"
          size="large"
        >
          导出
        </a-button>
      </a-row>
      <a-spin :spinning="loading" tip="数据加载中...">
        <a-table
          class="table"
          :pagination="pagination"
          :rowKey="(record, index) => index"
          :columns="columnsTodo"
          :data-source="list"
          @change="onChangePage"
          :scroll="{ x: '100%', y: `calc(100vh - ${sHeight}px )` }"
          :transformCellText="({ text }) => text ?? '--'"
          :sortDirections="['descend', 'ascend']"
        >
          <template #workOrderId="data">
            <div class="beRemindedUser">
              {{ data.record.workOrderId }}
              <!-- 转交标识 -->
              <div v-if="data.record.transferFlag === 1" class="turnFlgM flg z-fixed-c">转交</div>
            </div>
          </template>
          <!-- 新增医生和患者标签 -->
          <template #reminder="{ record }">
            <div
              :style="{ cursor: record.remindedType === 1 ? 'pointer' : 'default' }"
              @click="openPatientFile(record)"
            >
              <roles :solerType="record.remindedType" />
              <span>{{ record.reminder }}</span>
            </div>
          </template>
          <!-- 工单任务 -->
          <template #eventContent="data">
            <div class="beRemindedUser">
              <div class="flg lgFlg z-fixed-c" v-if="data.record.activityFlag == 1">临观</div>
              <!-- 医生拼接 -->
              <span class="pre" v-if="data.record.eventId === 'PatientRegisterFillHealthInfo'">
                {{ `${data.record.ucDoctorName}${data.record.workOrderTask}` }}
              </span>
              <!-- 问诊拼接 -->
              <span class="pre" v-else-if="data.record.eventId === 'PatientNotEvaluateConsult'">
                {{ `问诊${data.record.businessId}${data.record.workOrderTask}` }}
              </span>
              <span v-else class="pre">
                <!-- 编号 -->
                <div
                  v-html="brightenKeyword(data.record)"
                  @click="handleDetail(data.record)"
                  :class="{ pointer: data.record.serialNumber || data.record.reserveSn }"
                ></div>
              </span>
            </div>
          </template>
          <template #handle="{ record }">
            <a-button type="link" @click="viewDetails(record)">查看详情</a-button>
          </template>
        </a-table>
      </a-spin>
    </div>
    <the-detail
      v-model:visible="detail.detailVisible"
      :serialNumber="detail.serialNumber"
      :recordType="detail.recordType"
      :id="detail.id"
      mode="read"
    />
    <ADetail ref="aDetail" :reserveSn="reserveSn" />
    <PatientInfoDetails
      :showAllDialog="showAllDialog"
      :currentInfo="currentInfo"
      @handleCancel="handleCancel"
    />
  </div>
</template>
<script>
export default {
  name: 'Todo'
}
</script>
<script setup>
import TheDetail from '@/components/TheDetail/index.vue'
import { ref, reactive, onMounted, onUnmounted, nextTick, computed, watch } from 'vue'
import ADetail from '@/views/WorkPlace/components/Appoint/index.vue'
import { subStringToType, brightenKeyword } from '@/utils/index'
import { getWorkOrderListAsyn, getWorkOrderListByTaskId } from '@/api/Todo/index.js'
import { columnsTodo, paginationConfig } from './config.js'
import searchTools from './searchTools.vue'
import PatientInfoDetails from '@/components/PatientInfoDetails'
import useTableTools from '../hooks/useTableTools'
import { cloneDeep } from 'lodash-es'
import { message as Message } from 'ant-design-vue'
import { momentFormat } from '@/utils'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { useFilterCache } from '@/hooks/useFilterCache'
import { FILTER_CACHE_PAGE_KEYS } from '@/constants/filterCache'
import { defaultQuery } from './options'
const listQuery = ref({})
const searchRef = ref(null)
const loading = ref(false)
const detail = reactive({
  // the detail
  detailVisible: false,
  serialNumber: '',
  recordType: '',
  id: ''
})
const sHeight = ref(318)
const getHeight = () => {
  nextTick(() => {
    sHeight.value = (searchRef?.value?.clientHeight || 318) + 262
  })
}
const list = ref([])
const pagination = reactive(paginationConfig)
const store = useStore()
const route = useRoute()
const searchWorkorder = computed(() => store.state.workOrder.searchWorkorder)

const normalizeQueryParams = params => {
  return {
    ...cloneDeep(defaultQuery),
    ...cloneDeep(params),
    createTime: Array.isArray(params?.createTime)
      ? params.createTime
      : cloneDeep(defaultQuery.createTime),
    allocateTime: Array.isArray(params?.allocateTime) ? params.allocateTime : [],
    dealTime: Array.isArray(params?.dealTime) ? params.dealTime : [],
    completeTime: Array.isArray(params?.completeTime) ? params.completeTime : [],
    curPage: Number(params?.curPage || defaultQuery.curPage),
    pageSize: Number(params?.pageSize || defaultQuery.pageSize)
  }
}

const { queryParams, initFromCache, updateCache, resetCache } = useFilterCache({
  pageKey: FILTER_CACHE_PAGE_KEYS.WORK_ORDER_LIST,
  userId: computed(() => store.state.user.userId),
  defaultParams: defaultQuery,
  getInitParams: () => route.query,
  normalize: normalizeQueryParams
})

listQuery.value = cloneDeep(queryParams.value)

const queryFiltration = listParams => {
  //  过滤筛选条件
  var params = cloneDeep(listParams)
  const {
    allocateTime = [], //分配时间
    completeTime = [], //结束时间
    dealTime = [], //处理时间
    createTime = [], //创建时间
    workOrderIdList,
    allocationFlag
  } = params
  params = {
    ...params,
    allocateTimeStart: allocateTime.length > 0 ? allocateTime[0] : '',
    allocateTimeEnd: allocateTime.length > 1 ? allocateTime[1] : '',
    completeTimeStart: completeTime.length > 0 ? completeTime[0] : '',
    completeTimeEnd: completeTime.length > 1 ? completeTime[1] : '',
    dealTimeStart: dealTime.length > 0 ? dealTime[0] : '',
    dealTimeEnd: dealTime.length > 1 ? dealTime[1] : '',
    createTimeStart:
      createTime.length > 0 ? momentFormat(createTime[0], 'YYYY-MM-DD HH:mm:ss') : '',
    createTimeEnd: createTime.length > 1 ? momentFormat(createTime[1], 'YYYY-MM-DD HH:mm:ss') : '',
    workOrderIdList: workOrderIdList ? workOrderIdList.split('、') : [],
    unAllocatedFlag: allocationFlag ? 2 : null
  }
  const deleteKeyList = ['allocateTime', 'completeTime', 'dealTime', 'createTime', 'allocationFlag']
  deleteKeyList.forEach(item => {
    Reflect.deleteProperty(params, item)
  })
  return params
}
// const filterParams = params => {
//   var oldParams = cloneDeep(params)
//   const common = ['curPage', 'pageSize', 'sort', 'sortType']
//   for (const key in params) {
//     const val = params[key]
//     if (typeof val === 'object' && !val?.length) {
//       delete params[key]
//     } else if (typeof val === 'undefined' || val === null || val === '') {
//       delete params[key]
//     } else if (common.includes(key)) {
//       delete params[key]
//     }
//   }
//   var arr = Object.keys(params)
//   if (arr.length) {
//     return oldParams
//   } else {
//     return false
//   }
// }

let timer
const timerConfig = 60
//最多轮训60次
const times = ref(0)
const getList = () => {
  times.value = 0
  const params = queryFiltration(listQuery.value)
  if (params) {
    // 后端要求
    params.createTimeStart = params.createTimeStart
      ? momentFormat(params.createTimeStart, 'YYYY-MM-DD 00:00:00')
      : ''
    params.createTimeEnd = params.createTimeEnd
      ? momentFormat(params.createTimeEnd, 'YYYY-MM-DD 23:59:59')
      : ''
    loading.value = true
    getWorkOrderListAsyn(params)
      .then(data => {
        const { taskId } = data
        if (taskId) {
          timer = setInterval(() => {
            getListByTaskId(taskId, params.workOrderIdList)
          }, 1000)
          // 轮训
        } else {
          renderData(data, params.workOrderIdList)
        }
      })
      .catch(() => {
        loading.value = false
      })
  } else {
    resetData()
    Message.info('请选择搜索条件')
  }
}
const getListByTaskId = (taskId, workOrderIdList) => {
  ++times.value
  if (times.value > timerConfig) {
    clearInterval(timer)
    return false
  }
  getWorkOrderListByTaskId({ taskId }).then(data => {
    // taskStatus为0表示过期，1-执行中，2-执行完成
    const { taskStatus } = data
    if (taskStatus === 2) {
      clearInterval(timer)
      renderData(data, workOrderIdList)
    } else {
      if (times.value === timerConfig) {
        loading.value = false
        Message.error('数据量太大，查询超时，请缩小搜索范围后再重试')
      }
    }
  })
}
const renderData = (data, workOrderIdList) => {
  loading.value = false
  const { currPage, pageSize, totalCount } = data
  list.value = data.list
  pagination.current = currPage
  pagination.pageSize = pageSize
  pagination.total = totalCount
  pagination.showTotal = () => `共${totalCount}条`
  isOrderTransfer(data.list, workOrderIdList)
}
const resetData = () => {
  list.value = []
  pagination.current = 1
  pagination.pageSize = 10
  pagination.total = 0
  pagination.showTotal = () => `共${0}条`
}
const isOrderTransfer = (list = [], arr = []) => {
  const notFindOrder = []
  if (arr?.length) {
    const orderIdList = list.map(it => it.workOrderId) || []
    arr.forEach(it => {
      if (!orderIdList.includes(it)) {
        notFindOrder.push(it)
      }
    })
  }
  if (notFindOrder?.length) {
    const errMsg = `工单ID${notFindOrder.join('、')}不存在或暂无查看权限`
    Message.error(errMsg)
  }
}

const { normalizeExport } = useTableTools()
const exportLoading = ref(false)
const handleExport = async () => {
  const params = queryFiltration(queryParams.value)
  if (params) {
    exportLoading.value = true
    await normalizeExport(
      '/health-doctor-assistant/workOrderCenter/work-order-list/export',
      params,
      '工单记录',
      'post'
    )
    exportLoading.value = false
  } else {
    Message.info('请选择搜索条件')
  }
}
const searchList = params => {
  const nextParams = updateCache({
    ...queryParams.value,
    ...(params || {}),
    curPage: 1
  })
  listQuery.value = nextParams
  getList()
}
const resetQuery = () => {
  const nextParams = resetCache()
  listQuery.value = nextParams
  getList()
}
// 改变当前页
const onChangePage = (page, filters, sorter) => {
  const { field, order } = sorter
  const nextParams = {
    ...queryParams.value,
    curPage: page.current,
    pageSize: page.pageSize
  }
  if (order === 'descend') {
    // 降序
    nextParams.sortType = 1
    nextParams.sort = field
  } else if (order === 'ascend') {
    // 升序
    nextParams.sortType = 0
    nextParams.sort = field
  } else {
    nextParams.sortType = null
    nextParams.sort = ''
  }
  listQuery.value = updateCache(nextParams)
  getList()
}

// 查看处方单、预约单详情
const handleDetail = record => {
  const { serialNumber, businessType, reserveSn: reserveId, follUpPlanId } = record
  if (businessType === 7) {
    if (!reserveId) return
    reserveSn.value = reserveId.toString()
    nextTick(() => {
      aDetail.value.mVisible = true
      aDetail.value.initDetail()
    })
  } else if (businessType === 11 || businessType === 12) {
    if (!follUpPlanId) return
    detail.detailVisible = true
    detail.id = follUpPlanId
    detail.recordType = 'visit'
  } else {
    if (!serialNumber) return
    detail.serialNumber = serialNumber
    detail.recordType = subStringToType(serialNumber)
    detail.detailVisible = true
  }
}
const aDetail = ref(null)
const reserveSn = ref('')
// 查看工单详情
const showAllDialog = ref(false)
const currentInfo = ref({})
const viewDetails = data => {
  showAllDialog.value = true
  currentInfo.value = data
}
const handleCancel = () => {
  showAllDialog.value = false
  currentInfo.value = {}
}

const handleExternalSearch = payload => {
  if (!payload) return

  try {
    const params = JSON.parse(payload)
    const nextParams = updateCache({
      ...defaultQuery,
      ...params,
      curPage: 1
    })
    listQuery.value = nextParams
    store.commit('workOrder/SEARCH_WORK_ORDER', '')
    getList()
  } catch (error) {
    store.commit('workOrder/SEARCH_WORK_ORDER', '')
  }
}

onMounted(() => {
  getHeight()
  const initParams = initFromCache()
  listQuery.value = initParams

  if (searchWorkorder.value) {
    handleExternalSearch(searchWorkorder.value)
    return
  }

  getList()
})
onUnmounted(() => {
  clearInterval(timer)
})

watch(
  () => queryParams.value,
  value => {
    listQuery.value = cloneDeep(value)
  },
  {
    deep: true
  }
)

watch(
  () => searchWorkorder.value,
  value => {
    if (!value) return
    handleExternalSearch(value)
  }
)

// 打开患者档案
function openPatientFile(record) {
  if (record.remindedType === 1) {
    const params = {
      patientId: record.patientId,
      patientType: 1,
      doctorId: record.doctorId ? record.doctorId : null
    }
    // 患者
    store.dispatch('patientFile/openModal', params)
  } else {
    // message.info('请先选择患者')
  }
}
</script>

<style lang="scss" scoped>
.pre {
  // FIXME: font-size: 12px;
  color: #333333;
  .pointer {
    cursor: pointer;
  }
}
.beRemindedUser {
  position: relative;
  display: flex;
}

.turnFlgM {
  margin-left: 10px;
  background: rgb(255, 238, 217);
  color: rgb(255, 169, 64);
}

.lgFlg {
  background: rgba(158, 158, 158, 0.3);
  color: #333333;
  text-align: center;
  font-size: 8px;
  border-radius: 4px;
  width: 30px;
  height: 20px;
  min-width: 30px;
  min-height: 20px;
  margin-right: 2px;
}

.flg {
  position: relative;
  text-align: center;
  font-size: 10px;
  border-radius: 4px;
  width: 30px;
  height: 20px;
  min-width: 30px;
  min-height: 20px;
  margin-right: 2px;
}

.todo-container {
  position: relative;
  height: 100%;

  ::v-deep(.ant-tabs-tab) {
    padding: 20px 16px;
  }

  ::v-deep(.ant-tabs-bar) {
    margin: 0;
  }
}

.table {
  padding: 24px;

  ::v-deep(.ant-btn) {
    padding: 0;
  }
}

.search {
  position: relative;
  align-items: center;
  background-color: #fff;
}
</style>
